module.exports = __webpack_public_path__ + "static/media/seat-icon.63680d34.svg";